import { buildMakeMakeComercialUrlByEnv } from "../../../util/host-utilities";

export const MORE_LINKS = [
	{
		text: {
			default: "¿Qué es la lectura digital?",
			translationId: "links.digital_reading",
		},
		link: buildMakeMakeComercialUrlByEnv({ path: "/" }),
		external: true,
	},
	{
		text: {
			default: "Blog",
			translationId: "links.blog",
		},
		link: "/blog",
	},
	{
		text: {
			default: "Comunicación",
			translationId: "links.marketing_center",
		},
		link: "/comunicacion",
	},
	{
		text: {
			default: "MakeMake en Vivo",
			translationId: "links.makemake_live",
		},
		link: "/club-makemake?section=makemake-en-vivo",
	},
	{
		text: {
			default: "Casos de éxito",
			translationId: "links.success_stories",
		},
		link: "/club-makemake?section=planes-de-lectura",
	},
];

export const PRODUCTS_LINKS = [
	{
		text: {
			default: "Conoce más sobre MakeMake",
			translationId: "links.about_makemake",
		},
		link: buildMakeMakeComercialUrlByEnv({ path: "/about" }),
		external: true,
	},
	{
		text: {
			default: "MakeMake para colegios",
			translationId: "links.schools",
		},
		link: buildMakeMakeComercialUrlByEnv({ path: "/planes/colegios" }),
		external: true,
	},
	{
		text: {
			default: "MakeMake para bibliotecas públicas",
			translationId: "links.public_libraries",
		},
		link: buildMakeMakeComercialUrlByEnv({ path: "/planes/bibliotecas" }),
		external: true,
	},
	{
		text: {
			default: "Educación en línea",
			translationId: "links.homes",
		},
		link: buildMakeMakeComercialUrlByEnv({ path: "/planes/academia" }),
		external: true,
	},
	{
		text: {
			default: "Accesibilidad y privacidad de datos",
			translationId: "links.accessibility_privacy",
		},
		link: "/edtech-open-standard",
	},
	{
		text: {
			default: "Declaración de accesibilidad",
			translationId: "links.accessibility_statement",
		},
		link: "/accesibility-statement",
	},
	{
		text: {
			default: "Política de desarrollo de colección",
			translationId: "links.collection_development",
		},
		link: "/collection-development-policy",
	},
];
